<template>
	<div class="container">
		<h2>Live Postings</h2>
		<postCardList
			:posts="posts"
			:seller="true"
			:loading="loading"
			:showSort="true"
			defaultSort="Start Date"
			:sortByOptions="[
				'End Date',
				'Start Date',
				'Created Date',
				'Reference',
				'Heading',
				'Turnover'
			]"
		/>
	</div>
</template>

<script>
import postCardList from "@/components/postCardList.vue";
import { mapGetters } from "vuex";
import Repository from "@/store/Services/Repository.js";

export default {
	name: "LivePosts",
	metaInfo(){
		return{
			title: "IP-BID.com - My Live Posts"
		}
	},
	components: {
		postCardList
	},
	data() {
		return {
			loading: false,
			posts: []
		};
	},
	created() {
		this.loading = true;
	},
	async mounted() {
		await Repository.get("seller/posts?status=1", {
			headers: { Authorization: `Bearer ${this.token}` }
		}).then(response => {
			this.posts = response.data;
		});
		this.loading = false;
	},
	computed: {
		...mapGetters(["token"])
	}
};
</script>
